import React, { useContext, useState } from "react"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"
import { useUncancelSubscription } from "../../hooks/usePaddleHooks.js"
import { useTranslation } from "react-i18next"
import { Button } from "@shopify/polaris"

export const CancelUncancelSubscription = ({ activeSubscription }) => {
	const { state } = useContext(GlobalStateContext)
	const { t, i18n } = useTranslation()
	const uncancelSubscription = useUncancelSubscription()

	const [uncancelSubscriptionLoading, setUncancelSubscriptionLoading] =
		useState(false)

	const _uncancelSubscription = async () => {
		if (!activeSubscription.subscriptionId) return
		setUncancelSubscriptionLoading(true)
		await uncancelSubscription(activeSubscription.subscriptionId)
		setUncancelSubscriptionLoading(false)
		window.location.reload()
	}

	const openCancelSubscriptionPage = () => {
		if (!activeSubscription.subscriptionId) return

		// New functionality with Retain
		// if (window?.Paddle?.Retain?.initCancellationFlow && activeSubscription.subscriptionId) {
		// 	window.Paddle.Retain.initCancellationFlow({
		// 		subscriptionId: activeSubscription.subscriptionId
		// 	})
		// }

		const url = new URL(activeSubscription.cancelUrl)
		const panelId = url.pathname.split("/").pop()
		const token = url.searchParams.get("token")

		if (!panelId || !token) {
			window.open(activeSubscription.cancelUrl, "_blank")
			return
		}

		const subscriptionUrl = `${url.origin}/subscriptions/${activeSubscription.subscriptionId}/${panelId}?token=${token}`

		window.open(subscriptionUrl, "_blank")
	}

	return (
		<div style={{ width: "100%" }}>
			{activeSubscription.scheduledChangeAction === "cancel" ? (
				<>
					<div style={{ marginBottom: "0.5rem" }}>
						<span style={{ fontSize: "0.9rem", color: "#333" }}>
							{t("account.your_subscription_is_set_to_be")}{" "}
							<b>{t("account.cancelled")}</b>.
						</span>
						{activeSubscription.scheduledChangeDate && (
							<span style={{ fontSize: "0.9rem", color: "#333" }}>
								{" "}
								{t("account.effective_at")}{" "}
								<b>
									{new Date(
										activeSubscription.scheduledChangeDate,
									).toLocaleDateString(
										i18n.language || "en-US",
										{
											year: "numeric",
											month: "long",
											day: "numeric",
										},
									)}
								</b>
								.
							</span>
						)}
					</div>

					<Button fullWidth onClick={_uncancelSubscription}>
						{uncancelSubscriptionLoading ? (
							<svg width="1rem" height="1rem" viewBox="0 0 24 24">
								<g>
									<rect
										width="2"
										height="5"
										x="11"
										y="1"
										fill="currentColor"
										opacity=".14"
									></rect>
									<rect
										width="2"
										height="5"
										x="11"
										y="1"
										fill="currentColor"
										opacity=".29"
										transform="rotate(30 12 12)"
									></rect>
									<rect
										width="2"
										height="5"
										x="11"
										y="1"
										fill="currentColor"
										opacity=".43"
										transform="rotate(60 12 12)"
									></rect>
									<rect
										width="2"
										height="5"
										x="11"
										y="1"
										fill="currentColor"
										opacity=".57"
										transform="rotate(90 12 12)"
									></rect>
									<rect
										width="2"
										height="5"
										x="11"
										y="1"
										fill="currentColor"
										opacity=".71"
										transform="rotate(120 12 12)"
									></rect>
									<rect
										width="2"
										height="5"
										x="11"
										y="1"
										fill="currentColor"
										opacity=".86"
										transform="rotate(150 12 12)"
									></rect>
									<rect
										width="2"
										height="5"
										x="11"
										y="1"
										fill="currentColor"
										transform="rotate(180 12 12)"
									></rect>
									<animateTransform
										attributeName="transform"
										calcMode="discrete"
										dur="0.75s"
										repeatCount="indefinite"
										type="rotate"
										values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
									></animateTransform>
								</g>
							</svg>
						) : (
							<span style={{ fontSize: "0.777rem" }}>
								{t("account.uncancel_subscription")}
							</span>
						)}
					</Button>
				</>
			) : (
				<Button fullWidth onClick={openCancelSubscriptionPage}>
					{t("account.cancel_subscription")}
				</Button>
			)}
		</div>
	)
}
